import { getTreatmentsExtensionForGraphqlBody } from '@ms/yammer-data/dist/api';
import { getClientForwardExperiments } from '@ms/yammer-data/dist/domains/experiments/selectors';
import type { Store } from '@ms/yammer-data/dist/state/types';
import { LazyRelayAppWrapper } from '@ms/yammer-relay/dist/environment';
import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import type { YammerWebState } from '../../../state/types';
import config from '../../config';

interface RelayAppWrapperProps {
  readonly reduxStore: Store<YammerWebState>;
  readonly etag?: string;
}

const RelayAppWrapper: FC<PropsWithChildren<RelayAppWrapperProps>> = ({ children, reduxStore, etag }) => {
  const state = reduxStore.getState();
  const experiments = getClientForwardExperiments(state);
  const treatments = getTreatmentsExtensionForGraphqlBody({
    state,
    experiments: [...experiments, 'CommunityAgentAdmin', 'CommunityAgentPrivatePreview'],
  });
  const relayConfig = {
    authScope: config.adal.resources.yammer,
    host: config.hosts.graphql,
    treatments,
    etag,
  };

  return <LazyRelayAppWrapper {...relayConfig}>{children}</LazyRelayAppWrapper>;
};

export default RelayAppWrapper;
